import { IconRight } from '@ui/src';
import { AllActionsRowTypes } from './types';

import cn from './styles.module.css';

const AllActionsRow = ({
  onSelectRow,
  isSelectedRow,
  title,
  isEditable,
}: AllActionsRowTypes): React.JSX.Element =>
  onSelectRow ? (
    <button
      className={`${cn.allActionsRow} ${
        isSelectedRow ? cn.allActionsRowActive : ''
      }`}
      onClick={() => onSelectRow('all')}
      disabled={!isEditable}
      aria-label="select row"
      type="button"
    >
      <div className={cn.allActionsRowTitle}>{title}</div>
      <div className={cn.allActionsRowIcon}>
        <IconRight />
      </div>
    </button>
  ) : (
    <div />
  );

export default AllActionsRow;
